import { Typography, IconButton, Box, useTheme, Drawer } from '@mui/material'
import { attachmentThumbnails, getFileSizeFromBytes, formatDate } from '../../utils/utilities'
import CloseIcon from '@mui/icons-material/Close'
import { useLayoutContext } from '../../contexts/layout.context'
import { useStudyMaterialStore } from '../../store/studymaterial.store'

const DetailsViewer = ( { attachment, open, setShowDetails } ) => {

    const { border } = useTheme()
    const { navHeight } = useLayoutContext()

    const StudyMaterialStore = useStudyMaterialStore()


    return (
        <Drawer onClose={() => setShowDetails( null )} anchor="right" open={open} slotProps={{
            paper: { sx: { borderRadius: `10px 0 0 10px`, width: "90%", maxWidth: "300px", border: border[1] } }
        }} >
            <Box borderBottom={border[1]} color="black" padding="10px 20px" display="flex" gap="20px" alignItems="flex-start" justifyContent="space-between">
                <Box display="flex" gap="20px" sx={{ float: "left" }} maxWidth="250px" >
                    <Box display="inline-block" component='img' height="30px" src={attachmentThumbnails[attachment.study_material_attachment_type] ? attachmentThumbnails[attachment.study_material_attachment_type] : attachmentThumbnails["default"]} alt={attachment.study_material_attachment_type} />
                    <Typography lineHeight="1.2" variant='subtitle2' sx={{ wordBreak: "break-all", overflow: "hidden", display: "inline-block", wordWrap: "break-word" }}>{attachment.study_material_attachment_title || attachment.study_material_attachment_name}</Typography>
                </Box>
                <IconButton color="greyed" onClick={() => setShowDetails( null )}>
                    <CloseIcon />
                </IconButton>
            </Box>
            <Box overflow="auto" className="custom-scrollbar" padding="10px 20px" display="flex" flexDirection="column" gap="20px">
                {attachment.study_material_attachment_title &&
                    <Box>
                        <Typography variant='subtitle2' display="block" color='textSecondary' fontSize="12px">
                            Full name
                        </Typography>
                        <Typography variant='subtitle2' display="block" sx={{ wordBreak: "break-all", overflow: "hidden", }} fontWeight="normal">
                            {attachment.study_material_attachment_name}
                        </Typography>
                    </Box>
                }
                {StudyMaterialStore.getMaterial['studyMaterial']?.study_material_created_by && < Box >
                    <Typography variant='subtitle2' display="block" color='textSecondary' fontSize="12px">
                        File Uploaded By
                    </Typography>
                    <Typography variant='subtitle2' display="block" fontWeight="normal">
                        {StudyMaterialStore.getMaterial['studyMaterial']?.study_material_created_by}
                    </Typography>
                </Box>}
                <Box>
                    <Typography variant='subtitle2' display="block" color='textSecondary' fontSize="12px">
                        Downloads
                    </Typography>
                    <Typography variant='subtitle2' display="block" fontWeight="normal">
                        {attachment.attachment_download_count}
                    </Typography>
                </Box>
                <Box>
                    <Typography variant='subtitle2' display="block" color='textSecondary' fontSize="12px">
                        File Type
                    </Typography>
                    <Typography variant='subtitle2' display="block" fontWeight="normal">
                        {attachment.study_material_attachment_type}
                    </Typography>
                </Box>
                {attachment?.study_material_attachment_meta?.size > 0 && <Box>
                    <Typography variant='subtitle2' display="block" color='textSecondary' fontSize="12px">
                        File Size
                    </Typography>
                    <Typography variant='subtitle2' display="block" fontWeight="normal">
                        {getFileSizeFromBytes( attachment.study_material_attachment_meta.size )}
                    </Typography>
                </Box>}
                <Box>
                    <Typography variant='subtitle2' display="block" color='textSecondary' fontSize="12px">
                        File MIME
                    </Typography>
                    <Typography sx={{ wordBreak: "break-all" }} variant='subtitle2' display="block" fontWeight="normal">
                        {attachment.study_material_attachment_meta.mimetype}
                    </Typography>
                </Box>
                <Box>
                    <Typography variant='subtitle2' display="block" color='textSecondary' fontSize="12px">
                        Uploaded Date
                    </Typography>
                    <Typography variant='subtitle2' display="block" fontWeight="normal">
                        {formatDate( attachment.study_material_attachment_published_date, { format: 'lll' } )}
                    </Typography>
                </Box>
            </Box>
        </Drawer >
    )
}

export default DetailsViewer
